import React, { Component } from "react";

import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { removeThenAddRoles } from "../../actions/company/users";
import { findOwnManagedConnections } from "../../actions/connections/read";
import { listItems } from "../../actions/registry/read";
import { fetchItemServices } from "../../actions/services/service-subscription-v2";
import { getUserInfo } from "../../actions/user";
import { AccordionStepper } from "../../components/general/accordion-stepper";
import { AccordionStep } from "../../components/general/accordion-stepper/accordion-step";
import { errorBoundary } from "../../components/general/error-boundary";
import CreateApiKey from "../../components/manage-data/user/new-user-modal/create-api-key";
import SelectCompanies from "../../components/manage-data/user/new-user-modal/select-companies";
import SelectRoles from "../../components/manage-data/user/new-user-modal/select-roles";
import { getItemIdsFromRoles, mapUserRolesToAppId, parseApiKeyRoles, roleComparer } from "../../utils/get-roles";
import { Container } from "./styled";

export class EditApiKeyView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            availableItemsPage: 1,
            existingUser: false,
            existingUserModalOpen: false,
            apiKey: {},
            filter: "",
            initialSelectedItemIds: null,
            selectedItems: [],
            step: 1,
            submissionError: ""
        };
    }

    componentDidMount() {
        const { getUserInfo, match } = this.props;

        getUserInfo(match.params.selectedApiKey);
    }

    componentDidUpdate(prevProps) {
        const {
            connectionsLoading,
            findOwnManagedConnections,
            listItems,
            history,
            itemServicesLoading,
            match,
            rolesEditStatus,
            selectedItemId,
            userInfoStatus
        } = this.props;
        const { step } = this.state;

        if (prevProps.userInfoStatus.started && userInfoStatus.ended) {
            findOwnManagedConnections(
                {
                    active: true,
                    deleted: false,
                    managerIds: selectedItemId
                },
                { page: 0, size: 2000 }
            );
        }

        if (prevProps.connectionsLoading && !connectionsLoading) {
            const existingItems = this.getExistingSelectedItems();
            const firstPageItems = this.getAvailableItemsPage(1);

            const itemsToLoad = [...existingItems, ...firstPageItems];

            listItems(itemsToLoad);
            if (this.state.initialSelectedItemIds === null) {
                this.setState({ initialSelectedItemIds: existingItems });
            }
        }

        if (prevProps.itemServicesLoading && !itemServicesLoading) {
            this.setState({ step: step + 1 });
        }

        if (prevProps.rolesEditStatus.started && rolesEditStatus.ended) {
            history.push(`/${match.params.item}/registry/apikey/edit/success`);
        }
    }

    getAvailableItemsPage = pageNumber => {
        const { visibleItems } = this.props;
        const { filter } = this.state;

        return visibleItems
            .filter(
                i =>
                    i.id.toLowerCase().includes(filter.toLocaleLowerCase()) ||
                    i.description.toLowerCase().includes(filter.toLocaleLowerCase())
            )
            .slice((pageNumber - 1) * 5, pageNumber * 5)
            .map(i => i.id);
    };

    getExistingSelectedItems = () => {
        const { userInfo, visibleItems } = this.props;

        return getItemIdsFromRoles(userInfo.roles).filter(item => visibleItems.map(i => i.id).includes(item));
    };

    getExistingUserRoles = () => {
        const { userInfo } = this.props;
        const { selectedItems } = this.state;

        const selectedItemIds = selectedItems.map(i => i.id);

        return mapUserRolesToAppId(userInfo.roles, selectedItemIds);
    };

    getTotalItems = () => {
        const { visibleItems } = this.props;
        const { filter } = this.state;

        return visibleItems.filter(
            i =>
                i.id.toLowerCase().includes(filter.toLocaleLowerCase()) ||
                i.description.toLowerCase().includes(filter.toLocaleLowerCase())
        ).length;
    };

    handleCompanySearch = (value, page, size = 5) => {
        const { listItems } = this.props;

        const items = this.getAvailableItemsPage(page + 1);

        listItems(items);
        this.setState({ filter: value, availableItemsPage: page + 1 });
    };

    handleSelectAll = () => {
        const { listItems, visibleItems } = this.props;

        this.setState({ selectedItems: visibleItems.map(i => i.id) });
        listItems(visibleItems.map(i => i.id));
    };

    handleUserCreation = roles => {
        const { removeThenAddRoles, userInfo, userRoles, match } = this.props;

        const { initialSelectedItemIds, selectedItems } = this.state;

        const selectedItemIds = selectedItems.map(i => i.id);

        const oldRolesItemIds = new Set([...selectedItemIds, ...(initialSelectedItemIds || [])]);

        const newRoles = parseApiKeyRoles(roles, userRoles);
        const oldRoles = userInfo.roles.filter(oldrole => oldRolesItemIds.has(oldrole.resourceId));

        const onlyInNewRoles = roleComparer(newRoles, oldRoles);
        const onlyInOldRoles = roleComparer(oldRoles, newRoles);

        if ((onlyInNewRoles && onlyInNewRoles.length > 0) || (onlyInOldRoles && onlyInOldRoles.length > 0)) {
            removeThenAddRoles(match.params.selectedApiKey, onlyInNewRoles, onlyInOldRoles);
        } else {
            this.setState({
                submissionError: <FormattedMessage id="c-manage-data.multicompany-edit.no-edit" />
            });
        }
    };

    render() {
        const {
            agyoServices,
            companies,
            connectionsLoading,
            fetchItemServices,
            itemServices,
            itemServicesLoading,
            listItemsLoading,
            match,
            rolesEditStatus,
            userInfo,
            userRoles
        } = this.props;
        const { availableItemsPage, selectedItems, step, submissionError } = this.state;

        return (
            <Container>
                <AccordionStepper
                    backRedirectUrl={`/${match.params.item}/registry/apikey`}
                    currentStep={step}
                    displayEndButtons={step !== 2}
                >
                    <AccordionStep
                        title={<FormattedMessage id="c-manage-data.multicompany-create.create-tech-user" />}
                        subtitle={
                            <FormattedMessage id="c-manage-data.multicompany-create.create-tech-user-description" />
                        }
                    >
                        <CreateApiKey
                            initialValues={{
                                description: userInfo.profile.description
                            }}
                            loading={connectionsLoading}
                            onSubmit={() => {}}
                        />
                    </AccordionStep>
                    <AccordionStep
                        title={<FormattedMessage id="c-manage-data.multicompany-create.select-companies" />}
                        subtitle={
                            <FormattedMessage id="c-manage-data.multicompany-create.select-companies-description" />
                        }
                    >
                        <SelectCompanies
                            backDisabled={true}
                            companies={companies}
                            companiesPage={this.getAvailableItemsPage(availableItemsPage)}
                            initialSelectedItems={this.getExistingSelectedItems()}
                            loadingItems={listItemsLoading || connectionsLoading}
                            loadingNext={itemServicesLoading}
                            onBack={() => this.setState({ step: step - 1 })}
                            onSearch={this.handleCompanySearch}
                            onSelectAll={this.handleSelectAll}
                            onSubmit={items => {
                                fetchItemServices(items.map(i => i.id));
                                this.setState({
                                    selectedItems: items
                                });
                            }}
                            selectedItemsLoading={connectionsLoading}
                            totalItems={this.getTotalItems()}
                            userRoles={userRoles}
                        />
                    </AccordionStep>
                    <AccordionStep
                        title={<FormattedMessage id="c-manage-data.multicompany-create.select-roles" />}
                        subtitle={<FormattedMessage id="c-manage-data.multicompany-create.select-roles-description" />}
                    >
                        <SelectRoles
                            agyoServices={agyoServices}
                            backDisabled={false}
                            backUrl={`/${match.params.item}/registry/apikey`}
                            customRoles={this.getExistingUserRoles()}
                            endLoading={rolesEditStatus.started}
                            forwardDisabled={false}
                            itemServices={itemServices}
                            onBack={() => this.setState({ step: step - 1 })}
                            onSelectRoles={this.handleUserCreation}
                            selectedCompanies={selectedItems}
                            submissionError={rolesEditStatus.errorInfo.message || submissionError}
                            userRoles={userRoles}
                        />
                    </AccordionStep>
                </AccordionStepper>
            </Container>
        );
    }
}

const actions = {
    getUserInfo,
    findOwnManagedConnections,
    fetchItemServices,
    listItems,
    removeThenAddRoles
};

const mapStateToProps = (state, props) => {
    const { status: userInfoStatus, user: userInfo } = state.getUserInfo;

    const selectedItem = state.companies.data[props.match.params.item]
        ? state.companies.data[props.match.params.item].item
        : {};

    const visibleItems = state.connectionsNew.read.findOwnManagedConnections.content.map(link => ({
        id: link.managedId,
        description: link.managedDescription
    }));
    visibleItems.push({
        id: selectedItem.base.id,
        description: selectedItem.base.details.description
    });

    return {
        agyoServices: state.services.agyoServices,
        companies: Object.values(state.companies.totalRoleAdd.items)
            .map(i => i.item.base)
            .filter(i => visibleItems.map(visibleItem => visibleItem.id).includes(i.id)),
        connectionsLoading: state.connectionsNew.read.findOwnManagedConnections.status.started,
        itemServices: state.services.itemServices.services,
        itemServicesLoading: state.services.itemServices.status.started,
        listItemsLoading: state.registry.read.listItems.status.started,
        rolesEditStatus: state.manageUser.removeThenAddRoles,
        selectedItemId: selectedItem.base.id,
        userInfo: userInfo ? userInfo : { profile: {}, roles: [] },
        userInfoStatus: userInfoStatus,
        userRoles: state.user.user ? state.user.user.roles : [],
        visibleItems: visibleItems
    };
};

const composedHoc = compose(errorBoundary, withRouter, connect(mapStateToProps, actions));

export default composedHoc(EditApiKeyView);
